import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

import { ActionModalProps } from './types';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        minWidth: '560px',
        padding: '1.5rem 2.5rem'
    },
    primaryBorder: { borderTop: `12px solid ${theme?.app?.clientTheme.colors.primaryColor || '#375073'}` },
    approvalBorder: { borderTop: `12px solid ${theme?.app?.applicationColors.successDark || '#5AAC01'}` },
    declineBorder: { borderTop: `12px solid ${theme?.app?.applicationColors.failureDark || '#AD3D4B'}` },
    primaryHeader: {
        alignSelf: 'center',
        fontSize: '2rem',
        fontWeight: 'bold' as const,
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073'
    },
    approvalHeader: {
        alignSelf: 'center',
        fontSize: '2rem',
        fontWeight: 'bold' as const,
        color: theme?.app?.applicationColors.successDark || '#5AAC01'
    },
    declineHeader: {
        alignSelf: 'center',
        fontSize: '2rem',
        fontWeight: 'bold' as const,
        color: theme?.app?.applicationColors.failureDark || '#AD3D4B'
    },
    cancelIcon: {
        position: 'absolute' as const,
        top: '2.25rem',
        right: '1.5rem'
    },
    bodyContainer: { padding: '1rem 0' },
    cancelButton: {
        cursor: 'pointer' as const,
        fontSize: '1.2rem',
        lineHeight: '1.2rem',
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        padding: '.3rem',
        marginTop: '1rem',
        '&:hover': { backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHover || '#bec4cf' }
    },
    paperWidthXl: { width: (props: ActionModalProps) => (props.modalWidth ? `${Number(props.modalWidth)}%` : '80%') },
    '@media (max-width: 1360px)': { paperWidthXl: { width: '700px' }}
}));